
export class Campaign {
	public campaignID: string;
	public campaignName: string;
	public eMailContent: string;
	public emailJSON: string;
	public eMailSubject: string;
	public adminUserID: string;
	public emailTypeID: EmailType;
	public emailTypeDesc: string;
	public deliveryDateTime: Date;
	public campaignStatusID: CampaignStatus;
	public campaignStatusDesc: string;
	public vimeoVideoUrl: string;
	public sendAllEmployers: boolean;
	public employers: Array<string>;
	public employer: string;

	public startDripDate: Date;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

export enum CampaignStatus {
	Active = 1,
	Executing = 2,
	Complete = 3,
	Inactive = 4
}

export enum EmailType {
	Single = 1,
	Drip = 2,
}

export class DripProgram {
	public dripProgramID: string;
	public dripProgramName: string;
	public employerID: string;
	public startDate: Date;
	public deliveryTime: string;
	public paused: boolean;
	public catchUpInterval: number;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

export class DripProgramDetails {
	public dripProgramID: string;
	public campaignID: string;
	public sequence: number;
	public interval: number;
	public catchup: boolean;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}